<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :actions="actions"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      :selectionEnabled="true"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      ref="grid"
    ></dx-grid>

    <v-dialog
      persistent
      scrollable
      v-model="addAbsentReportDialog"
      max-width="1200"
    >
      <v-card>
        <v-card-title class="success white--text py-0 px-4">
          <span class="title" style="padding-top: 8px;">New Absent Report</span>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            icon
            flat
            small
            dark
            @click="addAbsentReportDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-layout row wrap>
            <v-flex xs12 sm4 class="pr-3">
              <!-- <v-select
                            class="mx-1 mb-0"
                            label="Driver / Bus"
                            v-model="newAbsentReport.driver_bus"
                            :items="
                                newAbsentReport.driver_busList.map(
                                    (b) => b.displayName,
                                )
                            "
                            ref="driver_bus"
                            clearable
                            :rules="[rules.required]"
                            @change="driverBusChanged"
                        ></v-select> -->

              <v-autocomplete
                class="mx-1 mb-0"
                label="Driver / Bus"
                v-model="newAbsentReport.driver_bus"
                :items="
                  newAbsentReport.driver_busList.map((b) => b.displayName)
                "
                ref="driver_bus"
                clearable
                :rules="[rules.required]"
                @change="driverBusChanged"
              ></v-autocomplete>

              <v-menu
                v-model="newAbsentReport.datePickerMenu"
                :close-on-content-click="false"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="newAbsentReport.dates"
                    label="Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newAbsentReport.dates"
                  multiple
                  @change="datesChanged"
                  style="height: 500px;"
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    outline
                    small
                    color="success"
                    @click="newAbsentReport.datePickerMenu = false"
                  >
                    Ok
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-autocomplete
                v-model="newAbsentReport.absentReason"
                label="Reason"
                :items="reasons.map((r) => r.reason)"
                ref="absentReason"
                :rules="[rules.required]"
                clearable
              ></v-autocomplete>

              <v-text-field
                v-model="newAbsentReport.note"
                label="Note"
              ></v-text-field>

              <v-text-field
                v-model="newAbsentReport.calendarNote"
                label="Calendar Note"
              ></v-text-field>

              <v-select
                v-model="newAbsentReport.geoUpdated"
                label="GEO Updated"
                :items="['YES', 'NO', 'N/A']"
              ></v-select>

              <v-select
                v-model="newAbsentReport.notifiedDriver"
                label="Notified Driver"
                :items="['YES', 'NO', 'N/A']"
              ></v-select>

              <div class="mt-3 mb-2 font-weight-medium">
                Sub Driver
              </div>
              <v-btn-toggle
                v-model="newAbsentReport.subDriverListFilter"
                @change="newAbsentReportSubDriverListFilterChanged"
              >
                <v-btn flat value="all" class="pa-2">
                  <span>All</span>
                </v-btn>
                <v-btn flat value="not_occupied" class="pa-2">
                  <span>Not Occupied</span>
                </v-btn>
              </v-btn-toggle>

              <v-autocomplete
                v-model="newAbsentReport.selectedSubDriver"
                :disabled="newAbsentReport.isUpdatingSubDriversList"
                :items="newAbsentReport.subDriversDisplayList"
                hide-details
                box
                chips
                color="success"
                class="mt-3"
                label="Select"
                item-text="displayName"
                item-value="id"
                clearable
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    class="chip--select-multi"
                    @input="removeNewAbsentReportSubDriver(data.item)"
                  >
                    {{ data.item.displayName }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content
                      v-text="data.item"
                    ></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title
                        v-html="data.item.displayName"
                      ></v-list-tile-title>
                      <v-list-tile-sub-title
                        v-html="data.item.group"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>

            <v-flex xs12 sm4 class="px-2">
              <v-layout
                class="ml-1 pl-1 mb-2"
                row
                style="max-height: fit-content;"
              >
                <v-select
                  class="pt-3"
                  v-model="kind"
                  label="Kind"
                  :items="kindOptions"
                  item-text="text"
                  item-value="value"
                  hide-details
                  style="max-width: 200px;"
                  @change="driverBusChanged(newAbsentReport.driver_bus)"
                ></v-select>
              </v-layout>

              <v-layout row align-center class="mt-2 mb-2 ml-1 pl-1">
                <v-icon small color="grey darken-1" class="mr-1"
                  >mdi-bus</v-icon
                >
                <span class="font-weight-medium">Routes</span>
              </v-layout>

              <div class="routes-section-card">
                <v-progress-linear
                  v-if="newAbsentReport.loadingRoutes"
                  :indeterminate="true"
                  color="success"
                ></v-progress-linear>
                <div
                  v-if="
                    !newAbsentReport.loadingRoutes &&
                      !newAbsentReport.routes.length
                  "
                  class="mt-0 ml-1 pl-1 font-weight-light grey--text"
                >
                  {{
                    !newAbsentReport.driver_bus || !newAbsentReport.dates.length
                      ? "Please Select Driver & Dates"
                      : "No Routes"
                  }}
                </div>

                <div v-if="newAbsentReport.routes.length" class="route-select-toolbar">
                  <v-checkbox
                    class="route-select-all mx-0 my-0 py-0"
                    :input-value="isAllRoutesSelected()"
                    @change="toggleSelectAllRoutes()"
                    label="Select All"
                    color="success"
                    hide-details
                  ></v-checkbox>

                  <div
                    class="route-group-row"
                    v-if="getRouteGroups().length > 1"
                  >
                    <span class="caption grey--text route-group-caption">Select by</span>
                    <label
                      v-for="group in getRouteGroups()"
                      :key="group"
                      class="route-group-chip"
                      :class="{ 'route-group-chip--checked': isGroupFullySelected(group) }"
                      @click.prevent="toggleRouteGroup(group)"
                    >
                      <v-checkbox
                        :input-value="isGroupFullySelected(group)"
                        color="success"
                        hide-details
                        readonly
                        class="route-group-check ma-0 pa-0"
                      ></v-checkbox>
                      <span>{{ group }}</span>
                    </label>
                  </div>
                </div>

                <div
                  style="overflow-y: auto; max-height: 420px;"
                  class="route-list-scroll"
                  v-if="newAbsentReport.routes.length"
                >
                  <v-checkbox
                    v-for="route in newAbsentReport.routes"
                    :key="routeChoiceKey(route)"
                    class="mx-1 my-0"
                    v-model="newAbsentReport.selectedRoutes"
                    :value="routeChoiceKey(route)"
                    :label="route.displayName"
                    color="success"
                  ></v-checkbox>
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm4 class="pl-3">
              <absent-deduction-panel
                ref="deductionPanel"
                class="mt-0"
                :driver-bus-id="selectedDriverId"
                :dates="newAbsentReport.dates"
                :kind="kind"
                :route-ids="selectedRouteIds"
                allow-edit-existing
                :deduction-mode="selectedDeductionMode"
                :absence-reason="newAbsentReport.absentReason"
              ></absent-deduction-panel>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="addAbsentReportDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="saveNewAbsentReport()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="updateSubDriverDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-2 pt-0"
          >Update Sub Driver</v-card-title
        >
        <div class="px-2 mt-2">
          <div style="overflow-y: auto; max-height: 300px">
            <div v-for="(absent, index) in selected">
              <div class="font-weight-regular">
                {{ absent.date | date }}
              </div>
              <div class="font-weight-medium">
                Driver - Bus:
                {{ absent.driver + " (" + absent.busNumber + ")" }}
              </div>
              <div class="caption">
                {{
                  absent.timeStart +
                    " - " +
                    absent.buildings +
                    " - " +
                    (absent.grades ? absent.grades : "")
                }}
              </div>
              <v-divider
                class="my-2"
                v-if="index + 1 < selected.length"
              ></v-divider>
            </div>
          </div>

          <v-select
            class="my-3 pb-1"
            v-model="geoUpdated"
            label="GEO Updated"
            :items="['YES', 'NO', 'N/A']"
            hide-details
          ></v-select>

          <v-select
            class="mb-2"
            v-model="notifiedDriver"
            label="Notified Driver"
            :items="['YES', 'NO', 'N/A']"
            hide-details
          ></v-select>

          <v-btn-toggle
            class="mt-3"
            v-model="subDriverListFilter"
            @change="subDriverListFilterChanged"
          >
            <v-btn flat value="all" class="pa-2">
              <span>All</span>
            </v-btn>
            <v-btn flat value="not_occupied" class="pa-2">
              <span>Not Occupied</span>
            </v-btn>
          </v-btn-toggle>

          <v-autocomplete
            v-model="selectedSubDriver"
            :disabled="isUpdatingSubDriversList"
            :items="subDriversDisplayList"
            hide-details
            box
            chips
            color="success"
            class="mt-3"
            label="Select"
            item-text="displayName"
            item-value="id"
            clearable
          >
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removeSubDriver(data.item)"
              >
                {{ data.item.displayName }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="data.item.displayName"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="data.item.group"
                  ></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </div>
        <v-card-actions class="mr-0 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="updateSubDriverDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="saveSubDriver">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <deduction-impact-dialog
      v-model="deleteDialog"
      title="Delete Absent Reports"
      :intro="
        'The ' +
          selected.length +
          ' selected absence' +
          (selected.length === 1 ? '' : 's') +
          ' will be deleted.'
      "
      confirm-text="Delete"
      :loading="payImpactLoading"
      :confirm-loading="processing"
      :days="payImpactDays"
      @confirm="deleteReports"
    ></deduction-impact-dialog>

    <v-dialog persistent v-model="changeRouteDialog" max-width="1000">
      <change-route
        :selected="selected"
        :reload="reload"
        :close="closeChangeRouteDialog"
      ></change-route>
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      v-model="updateAbsentReportDialog"
      :max-width="canEditExistingDeductions ? 1200 : 900"
    >
      <update-absent
        :absent="rowClicked"
        :reload="reload"
        :closeAbsentReportDialog="closeAbsentReportDialog"
      ></update-absent>
    </v-dialog>

    <v-dialog persistent v-model="reasonsDialog" max-width="760">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Absent Reasons</v-card-title>
        <div class="caption grey--text mb-3 ml-3">
          Apply the usual deduction uses the amount calculated from the routes.
          Do not deduct preselects no deduction when that reason is chosen.
        </div>

        <v-layout row class="ml-3">
          <v-btn small color="success" class="mb-3" @click="addReason"
            >Add Reason</v-btn
          >
          <v-btn
            small
            color="success"
            class="mb-3 ml-2"
            v-if="reasons.some((l) => l.selected)"
            @click="deleteReasons"
            :loading="processing"
            >Delete Reasons</v-btn
          >
        </v-layout>

        <div v-for="(reason, index) in newReasons">
          <v-layout row class="pa-0 ml-3 mb-0" align-center>
            <v-text-field
              class="mx-2"
              v-model="reason.reason"
              label="Reason"
            ></v-text-field>
            <v-select
              class="mx-2"
              style="max-width: 280px;"
              v-model="reason.deductionMode"
              :items="deductionModes"
              item-text="text"
              item-value="value"
              label="Deduction"
            ></v-select>

            <v-btn @click="addReason" flat icon color="success">
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
            <v-btn @click="removeReason(index)" flat icon color="#f55a4e">
              <v-icon>mdi-minus-circle-outline</v-icon>
            </v-btn>
          </v-layout>
        </div>
        <v-btn
          color="success"
          small
          class="ml-3 mt-0 mb-4"
          :loading="processing"
          @click="saveNewReasons"
          v-if="newReasons.length"
          >Save</v-btn
        >

        <v-divider class="pb-0 pt-1"></v-divider>
        <div style="height: 450px; overflow-y: auto;">
          <div v-for="(reason, index) in reasons">
            <v-layout column class="pa-0 ml-3 mb-0">
              <v-layout row>
                <v-checkbox
                  class="width-50 pt-2 my-0"
                  hide-details
                  v-model="reason.selected"
                  v-if="!reason.editing"
                  color="success"
                ></v-checkbox>

                <div class="pt-2" v-if="!reason.editing">
                  <div>{{ reason.reason }}</div>
                  <div class="caption grey--text">
                    {{ deductionModeLabel(reason.deductionMode) }}
                  </div>
                </div>
                <div v-if="reason.editing" class="mx-2" style="flex: 1;">
                  <v-text-field
                    v-model="reason.reason"
                    label="Reason"
                    ref="reason"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-select
                    v-model="reason.deductionMode"
                    :items="deductionModes"
                    item-text="text"
                    item-value="value"
                    label="Deduction"
                  ></v-select>
                </div>

                <v-btn
                  small
                  color="default"
                  dark
                  @click="rollbackReason(reason)"
                  class="mx-2"
                  v-if="reason.editing"
                  style="height: 28px;"
                  >Cancel</v-btn
                >
                <v-btn
                  small
                  color="success"
                  @click="saveReason(reason)"
                  class="mx-2"
                  :loading="processing"
                  v-if="reason.editing"
                  style="height: 28px;"
                  >Save</v-btn
                >

                <v-btn
                  @click="editReason(reason)"
                  v-if="!reason.editing"
                  flat
                  icon
                  class="my-0 pb-1 pt-0"
                  color="success"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-layout>
            </v-layout>
            <v-divider
              class="pb-0 pt-1"
              v-if="index + 1 < reasons.length"
            ></v-divider>
          </div>
        </div>
        <v-card-actions class="mx-0 px-2 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="reasonsDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="payPresetsDialog" max-width="480">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Pay Presets</v-card-title>
        <div class="caption grey--text mb-3">
          DAY / AM / PM auto-fill when classification is clear. A full morning
          or afternoon plus other routes also offers the per-route amount.
          The yearly bonus here is the fallback when a season has no bonus of
          its own. Set the season bonus under Route Seasons.
        </div>
        <v-text-field
          v-model.number="payPresets.day"
          label="Full day (DAY)"
          prefix="$"
          type="number"
        ></v-text-field>
        <v-text-field
          v-model.number="payPresets.am"
          label="AM"
          prefix="$"
          type="number"
        ></v-text-field>
        <v-text-field
          v-model.number="payPresets.pm"
          label="PM"
          prefix="$"
          type="number"
        ></v-text-field>
        <v-text-field
          v-model.number="payPresets.trip"
          label="Trip suggestion"
          prefix="$"
          type="number"
        ></v-text-field>
        <v-text-field
          v-model.number="payPresets.yearlyBonus"
          label="Yearly bonus"
          prefix="$"
          type="number"
        ></v-text-field>
        <v-card-actions class="mx-0 px-2 pb-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="payPresetsDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="success" :loading="processing" @click="savePayPresets">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="driverReportDialog" max-width="560">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Driver Report</v-card-title>

        <v-layout row align-center class="mb-2">
          <v-autocomplete
            class="mx-1 mb-0"
            label="Driver / Bus"
            v-model="driverReport.driver_buses"
            :items="newAbsentReport.driver_busList.map((b) => b.displayName)"
            ref="driverReportDriverBus"
            clearable
            :rules="[rules.required]"
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text caption"
                >(+{{ driverReport.driver_buses.length - 1 }} others)</span
              >
            </template>
          </v-autocomplete>
          <v-btn
            small
            color="success"
            class="mx-1 mb-1"
            @click="selectAllDriverBuses"
          >
            Select All
          </v-btn>
        </v-layout>
        <div class="caption grey--text mb-1">Date range</div>
        <div class="mb-2">
          <v-btn
            small
            class="mr-2 mb-1"
            :outline="driverReport.dateRangePreset !== 'all'"
            color="success"
            @click="setDriverReportRange('all')"
          >
            All dates
          </v-btn>
          <v-btn
            small
            class="mr-2 mb-1"
            :outline="driverReport.dateRangePreset !== 'lastYear'"
            color="success"
            @click="setDriverReportRange('lastYear')"
          >
            Last year
          </v-btn>
          <v-btn
            small
            class="mr-2 mb-1"
            :outline="driverReport.dateRangePreset !== 'thisYear'"
            color="success"
            @click="setDriverReportRange('thisYear')"
          >
            This year
          </v-btn>
          <v-btn
            small
            class="mb-1"
            :outline="driverReport.dateRangePreset !== 'janJulLastYear'"
            color="success"
            @click="setDriverReportRange('janJulLastYear')"
          >
            Jan–Jul last year
          </v-btn>
        </div>
        <v-layout row class="mb-1">
          <v-menu
            v-model="driverReport.fromDatePickerMenu"
            :close-on-content-click="false"
            offset-y
            full-width
            class="mx-1"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="driverReport.fromDate"
                :value="driverReport.fromDate"
                label="From Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                class="mx-1 mb-0"
                ref="driverReportFromDate"
                :rules="[rules.required]"
                hide-details
              ></v-text-field>
            </template>
            <v-card>
              <v-date-picker
                v-model="driverReport.fromDate"
                scrollable
                @input="onDriverReportDatePicked('from')"
              ></v-date-picker>
              <v-card-actions class="pa-2">
                <v-btn
                  small
                  flat
                  color="success"
                  @click="jumpDriverReportPickerYear('from', -1)"
                >
                  Previous year
                </v-btn>
                <v-btn
                  small
                  flat
                  color="success"
                  @click="jumpDriverReportPickerYear('from', 1)"
                >
                  Next year
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  small
                  flat
                  @click="driverReport.fromDatePickerMenu = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          <v-menu
            v-model="driverReport.toDatePickerMenu"
            :close-on-content-click="false"
            offset-y
            full-width
            class="mx-1"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="driverReport.toDate"
                :value="driverReport.toDate"
                label="To Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                class="mx-1 mb-0"
                ref="driverReportToDate"
                :rules="[rules.required]"
                hide-details
              ></v-text-field>
            </template>
            <v-card>
              <v-date-picker
                v-model="driverReport.toDate"
                scrollable
                @input="onDriverReportDatePicked('to')"
              ></v-date-picker>
              <v-card-actions class="pa-2">
                <v-btn
                  small
                  flat
                  color="success"
                  @click="jumpDriverReportPickerYear('to', -1)"
                >
                  Previous year
                </v-btn>
                <v-btn
                  small
                  flat
                  color="success"
                  @click="jumpDriverReportPickerYear('to', 1)"
                >
                  Next year
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  small
                  flat
                  @click="driverReport.toDatePickerMenu = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-layout>

        <div class="caption grey--text mb-1">Report Type</div>
        <v-radio-group
          v-model="driverReport.reportMode"
          row
          class="mt-0 mb-2"
          hide-details
        >
          <v-radio
            label="Summary (match calendar)"
            value="summary"
            color="success"
          ></v-radio>
          <v-radio
            label="Detailed (one row per route)"
            value="detailed"
            color="success"
          ></v-radio>
        </v-radio-group>

        <div class="caption grey--text mb-1">Season</div>
        <v-radio-group
          v-model="driverReport.seasonMode"
          column
          class="mt-0 mb-1"
          hide-details
        >
          <v-radio
            label="Auto — match the day's absences (recommended)"
            value="auto"
            color="success"
          ></v-radio>
          <v-radio
            label="Selected season"
            value="selected"
            color="success"
          ></v-radio>
          <v-radio
            label="All overlapping seasons"
            value="alloverlapping"
            color="success"
          ></v-radio>
        </v-radio-group>
        <div class="caption grey--text mb-3" style="line-height: 1.4">
          Auto matches the calendar: an ALL day in Year Round 2026 stays ALL
          even if Year Round 2025 or Summer also covers that date. Use
          overlapping seasons only if you need the old mixed-season rows.
        </div>

        <v-layout
          v-if="driverReport.seasonMode === 'selected'"
          row
          class="mb-2"
        >
          <v-select
            class="mx-1 mb-0"
            v-model="driverReport.season"
            label="Season"
            :items="seasons"
            hide-details
          ></v-select>
        </v-layout>

        <v-card-actions class="mx-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="driverReportDialog = false"
            >Close</v-btn
          ><v-btn
            :loading="processing"
            color="success"
            @click="loadDriverReport"
            >Load Report</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="unsavedAbsentsDialog" max-width="800">
      <v-card class="pa-3">
        <v-card-title class="headline pb-0 pl-0 pt-0 error--text">
          <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
          Duplicate Records Found
        </v-card-title>

        <v-card-text class="pb-2">
          <div class="subtitle-1 mb-3">
            {{ unsavedAbsents.length }} record(s) could not be saved because
            duplicate entries already exist in the database.
          </div>

          <div style="max-height: 400px; overflow-y: auto;">
            <v-card
              v-for="(item, index) in unsavedAbsents"
              :key="index"
              class="mb-2 error-border"
              elevation="2"
            >
              <v-card-text class="pb-2">
                <div class="subtitle-2 font-weight-bold mb-2 error--text">
                  Existing Record Found:
                </div>
                <v-layout row wrap>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Date</div>
                    <div class="body-2">
                      {{ item.existingRecord.date | date }}
                    </div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Time</div>
                    <div class="body-2">
                      {{ item.existingRecord.timeStart || "N/A" }}
                    </div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Building</div>
                    <div class="body-2">
                      {{ item.existingRecord.buildings || "N/A" }}
                    </div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Grades</div>
                    <div class="body-2">
                      {{ item.existingRecord.grades || "N/A" }}
                    </div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Group</div>
                    <div class="body-2">
                      {{ item.existingRecord.groupBy || "N/A" }}
                    </div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Driver</div>
                    <div class="body-2">
                      {{ item.existingRecord.driver || "N/A" }}
                    </div>
                  </v-flex>
                  <v-flex xs6 class="mb-2">
                    <div class="caption grey--text">Bus Number</div>
                    <div class="body-2">
                      {{ item.existingRecord.busNumber || "N/A" }}
                    </div>
                  </v-flex>
                  <v-flex xs12 class="mb-2">
                    <div class="caption grey--text">Reason</div>
                    <div class="body-2">{{ item.reason }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
        </v-card-text>

        <v-card-actions class="mx-0 px-2 pb-2 mt-0">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="unsavedAbsentsDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";
import {
  toISOLocal,
  groupBy,
  getStoredRouteKind,
  setStoredRouteKind,
} from "../../utils/helpers.js";
import updateAbsent from "./UpdateAbsent.vue";
import changeRoute from "./ChangeRoute.vue";
import absentDeductionPanel from "./components/AbsentDeductionPanel.vue";
import deductionImpactDialog from "./components/DeductionImpactDialog.vue";
import {
  canEditExistingDeductions,
  deductionModes,
  deductionModeLabel as labelForDeductionMode,
} from "./deductionAccess";

export default {
  components: {
    updateAbsent,
    changeRoute,
    absentDeductionPanel,
    deductionImpactDialog,
  },
  data: () => ({
    title: "Absent Reports",

    actions: [],

    updateDriverDialog: false,
    addAbsentReportDialog: false,

    newAbsentReport: {
      datePickerMenu: false,
      dates: [],
      //route: "",
      driver_bus: "",
      note: "",
      calendarNote: "",
      absentReason: "",
      geoUpdated: "",
      notifiedDriver: "",
      routes: [],
      driver_busList: [],
      selectedRoutes: [],
      loadingRoutes: false,
      selectedSubDriver: "",
      isUpdatingSubDriversList: false,
      subDriversDisplayList: [],
      subDrivers: [],
      subDriverListFilter: "all",
    },

    updateAbsentReportDialog: false,
    rowClicked: {
      driver: "",
      busNumber: "",
      timeStart: "",
      buildings: "",
      grades: "",
      datePickerMenu: false,
      date: "",
    },

    updateAbsentReport: {
      selectedSubDriver: "",
      isUpdatingSubDriversList: false,
      subDriversDisplayList: [],
      subDrivers: [],
      subDriverListFilter: "all",
    },

    processing: false,
    deleteDialog: false,
    payImpactLoading: false,
    payImpactDays: [],
    updateSubDriverDialog: false,
    changeRouteDialog: false,
    subDrivers: [],
    subDriversDisplayList: [],
    selectedSubDriver: "",
    isUpdatingSubDriversList: false,
    subDriverListFilter: "all",
    deleting: false,
    selected: [],
    files: [],
    url: "",
    employeeList: [],
    employees: [],
    employees2: [],
    loadEmployeeSearch: null,
    loadClickedEmployeeSearch: null,
    loadClickedBusesSearch: null,
    selectedEmployee: "",
    clickedEmployee: "",

    clickedBuses: "",
    buses: [],
    busList: [],

    driverBuses: [],

    reasonsDialog: false,
    newReasons: [],
    reasons: [],
    deductionModes: deductionModes,
    payPresetsDialog: false,
    payPresets: {
      day: 0,
      am: 0,
      pm: 0,
      trip: 0,
      yearlyBonus: 4500,
    },

    geoUpdated: "",
    notifiedDriver: "",
    terms: [],
    regID: "",
    seasons: [],
    season: "",
    kind: "Regular",
    kindOptions: [
      { text: "Regular", value: "Regular" },
      { text: "Day Camp", value: "DayCamp" },
    ],
    driverReportDialog: false,

    driverReport: {
      driver_buses: [],
      fromDate: "",
      toDate: "",
      fromDatePickerMenu: false,
      toDatePickerMenu: false,
      dateRangePreset: "",
      skipPickerClose: false,
      reportMode: "summary",
      seasonMode: "auto",
      season: "",
      regID: "",
    },

    unsavedAbsentsDialog: false,
    unsavedAbsents: [],

    rules: {
      required: (value) => !!value || "Required.",
      busNumberRequired: (value, bus) => {
        return !bus.dateFrom || !bus.dateFrom || !!value || "Required.";
      },
      phoneNumber: (v) => {
        return (
          !v ||
          ([10, 11].includes(v.replace(/-/g, "").length) &&
            /^\d+$/.test(v.replace(/-/g, ""))) ||
          "Invalid Phone Number"
        );
      },
    },

    columns: [
      {
        label: "Driver",
        field: "driver",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Bus Number",
        field: "busNumber",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Date",
        field: "date",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Route Description",
        field: "description",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Time Start",
        field: "timeStart",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Direction",
        field: "direction",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Sub Driver",
        field: "subDriver",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Absent Reason",
        field: "absentReason",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "GEO Updated",
        field: "geoUpdated",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Notified Driver",
        field: "notifiedDriver",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Note",
        field: "note",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Calendar Note",
        field: "calendarNote",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Buildings",
        field: "buildings",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Grades",
        field: "grades",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Week Days",
        field: "weekDays",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Color",
        field: "color",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Notes",
        field: "notes",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Entered By",
        field: "enteredBy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Entered On",
        field: "enteredOn",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  watch: {
    loadEmployeeSearch(value) {
      if (!value) return;
      if (!this.employeeList.length) return;

      this.employees = this.employeeList.filter((b) =>
        b.displayName.toUpperCase().includes(value.toUpperCase())
      );
    },
    loadClickedEmployeeSearch(value) {
      if (!value) return;
      if (!this.employeeList.length) return;

      this.employees2 = this.employeeList.filter((b) =>
        b.displayName.toUpperCase().includes(value.toUpperCase())
      );
    },
    loadClickedBusesSearch(value) {
      if (!value) return;
      if (!this.busList.length) return;

      this.buses = this.busList.filter((b) =>
        b.busNumber.toUpperCase().includes(value.toUpperCase())
      );
    },
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    },
    "newAbsentReport.dates": {
      handler(newVal) {
        this.datesChanged(newVal);
      },
      deep: true,
    },
  },
  computed: {
    canEditExistingDeductions() {
      return canEditExistingDeductions(this.$store);
    },
    selectedDriverId() {
      const driver = this.newAbsentReport.driver_busList.find(
        (d) => d.displayName == this.newAbsentReport.driver_bus
      );
      return driver ? driver.id : null;
    },
    selectedRouteIds() {
      return this.distinctRouteIds(this.newAbsentReport.selectedRoutes);
    },
    selectedDeductionMode() {
      const match = this.reasons.find(
        (r) => r.reason == this.newAbsentReport.absentReason
      );
      return match && match.deductionMode === "NoDeduct"
        ? "NoDeduct"
        : "Calculated";
    },
  },
  mounted() {},
  beforeDestroy() {},
  async created() {
    this.loadDriverBusList();
    this.loadSubDriverList();
    this.loadEmployees();
    this.loadBuses();
    this.loadReasons();

    this.loadKind();
    this.loadSeasons();
    this.loadTerms();
    this.loadRegID();
  },
  methods: {
    async beforeSetupGrid() {
      this.actions.push({
        text: "Actions",
        isMenu: true,
        items: [
          {
            value: "report-absent",
            text: "Report Absent",
          },
          {
            value: "delete-absent-reports",
            text: "Delete Absent Reports",
            showOnSelection: true,
          },
          {
            value: "update-sub-drivers",
            text: "Update Sub Drivers",
            showOnSelection: true,
          },
          {
            value: "change-route",
            text: "Change Route / Detach",
            showOnSelection: true,
          },
          {
            value: "absent-reasons",
            text: "Absent Reasons",
          },
          {
            value: "driver-report",
            text: "Driver Report",
          },
          {
            value: "pay-presets",
            text: "Pay Presets",
          },
        ],
        value: "Actions",
        name: "Actions",
        action: this.openActionModal,
      });

      this.url = "driverAbsent";
    },
    openActionModal(option) {
      // const selected = this.$refs.grid.getSelectedRowsData();

      // if (option != "add-route" && !selected.length) {
      //     return this.$notify({
      //         group: "notification",
      //         text: "No Routes Selected",
      //         type: "error",
      //     });
      // }

      switch (option) {
        case "absent-reasons":
          return this.openReasonsDialog();
        case "delete-absent-reports":
          return this.openDeleteAbsentReports();
        case "update-sub-drivers":
          return this.openUpdateSubDrivers();
        case "change-route":
          return this.openChangeRoute();
        case "report-absent":
          return this.addAbsentReport();
        case "driver-report":
          return this.openDriverReportDialog();
        case "pay-presets":
          return this.openPayPresetsDialog();
      }
    },
    openReasonsDialog() {
      this.reasonsDialog = true;
    },
    async loadReasons() {
      this.reasons = await this.$http.get(
        "api/driverAbsent/GetDriverAbsentReasons"
      );
    },
    deductionModeLabel(mode) {
      return labelForDeductionMode(mode);
    },
    addReason() {
      this.newReasons.push({
        reason: "",
        deductionMode: "Calculated",
      });
    },
    removeReason(index) {
      this.newReasons.splice(index, 1);
    },
    editReason(reason) {
      reason.original = reason.reason;
      reason.originalDeductionMode = reason.deductionMode || "Calculated";
      if (!reason.deductionMode) {
        reason.deductionMode = "Calculated";
      }
      reason.editing = true;

      this.$forceUpdate();
    },
    rollbackReason(reason) {
      reason.reason = reason.original;
      reason.deductionMode = reason.originalDeductionMode;
      reason.editing = false;

      this.$forceUpdate();
    },
    async saveReason(reason) {
      const editingList = this.reasons.filter((r) => r.editing);
      const element = editingList.find((r) => r.id == reason.id);
      const index = editingList.indexOf(element);

      if (!this.$refs.reason[index].validate(true)) return;

      try {
        this.processing = true;

        await this.$http.post("api/driverAbsent/updateReason", reason);

        reason.original = "";
        reason.editing = false;

        this.$notify({
          group: "notification",
          text: "Reason Updated",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
        this.processing = false;
      } catch (e) {
        this.processing = false;
      }
    },
    async saveNewReasons() {
      try {
        if (this.newReasons.some((b) => !b.reason)) {
          return this.$notify({
            text: "Reason can't be empty",
            group: "notification",
            type: "error",
          });
        }

        this.processing = true;

        await this.$http.post(
          "api/driverAbsent/SaveAbsentReportReasons",
          this.newReasons.map((r) => ({
            reason: r.reason,
            deductionMode: r.deductionMode || "Calculated",
          }))
        );

        this.loadReasons();
        this.newReasons = [];
        this.processing = false;
      } catch (e) {
        this.processing = false;
      }
    },
    async deleteReasons() {
      try {
        this.processing = true;

        await this.$http.post(
          "api/driverAbsent/DeleteAbsentReportReasons",
          this.reasons.filter((d) => d.selected).map((reason) => reason.id)
        );

        this.loadReasons();
        this.processing = false;
      } catch (e) {
        this.processing = false;
      }
    },
    async loadDriverBusList() {
      const response = await this.$http.get("api/route/getDriverBusList");

      this.newAbsentReport.driver_busList = response
        .map((driverBus) => {
          driverBus.displayName =
            (driverBus.nameH ? driverBus.nameH : driverBus.name) +
            " - " +
            driverBus.busNumber;

          return driverBus;
        })
        .sort((a, b) => {
          const busNumberA = parseInt(a.busNumber) || 0;
          const busNumberB = parseInt(b.busNumber) || 0;
          return busNumberA - busNumberB;
        });
    },
    async loadSubDriverList() {
      this.selectedSubDriver = "";

      // if (this.absent.date.includes("Z")) {
      //     this.absent.date = toISOLocal(
      //         new Date(this.absent.date),
      //     ).substr(0, 10);
      // } else {
      //     this.absent.date = new Date(this.absent.date)
      //         .toISOString()
      //         .substr(0, 10);
      // }

      const response = await this.$http.post(
        "api/driverAbsent/getSubDrivers",
        []
      );

      this.subDrivers = response
        .map((driver) => {
          driver.displayName =
            (driver.nameH ? driver.nameH : driver.name) +
            " (" +
            driver.busNumber +
            ")";

          driver.group = driver.isOccupied ? "Occupied" : "Not Occupied";

          if (driver.position == "Substitute")
            driver.group += ` <span class='substitute-option'>Substitute</span>`;

          return driver;
        })
        .sort((a, b) => {
          if (a.group < b.group) {
            return -1;
          }
          if (a.group > b.group) {
            return 1;
          }
          return 0;
        });

      this.subDrivers = this.subDrivers.reduce((acc, curr) => {
        const { group } = curr;

        let groupHeader = group;

        groupHeader = groupHeader.replace(
          ` <span class='substitute-option'>Substitute</span>`,
          ``
        );

        const foundIndex = acc.findIndex((item) => item.group === groupHeader);
        // if group is not yet added
        if (foundIndex === -1) {
          // add divider after full list of Not Occupied
          if (groupHeader === "Occupied") {
            acc.push({ divider: true });
          }
          acc.push({
            header: groupHeader.toUpperCase(),
          });
        }
        acc.push(curr);
        return acc;
      }, []);

      this.subDriversDisplayList = this.subDrivers;
    },
    async loadNewAbsentReportSubDriverList() {
      this.newAbsentReport.selectedSubDriver = "";

      const response = await this.$http.post(
        "api/driverAbsent/getSubDrivers",
        []
      );

      this.newAbsentReport.subDrivers = response
        .map((driver) => {
          driver.displayName =
            (driver.nameH ? driver.nameH : driver.name) +
            " (" +
            driver.busNumber +
            ")";

          driver.group = driver.isOccupied ? "Occupied" : "Not Occupied";

          if (driver.position == "Substitute")
            driver.group += ` <span class='substitute-option'>Substitute</span>`;

          return driver;
        })
        .sort((a, b) => {
          if (a.group < b.group) {
            return -1;
          }
          if (a.group > b.group) {
            return 1;
          }
          return 0;
        });

      this.newAbsentReport.subDrivers = this.newAbsentReport.subDrivers.reduce(
        (acc, curr) => {
          const { group } = curr;

          let groupHeader = group;

          groupHeader = groupHeader.replace(
            ` <span class='substitute-option'>Substitute</span>`,
            ``
          );

          const foundIndex = acc.findIndex(
            (item) => item.group === groupHeader
          );
          // if group is not yet added
          if (foundIndex === -1) {
            // add divider after full list of Not Occupied
            if (groupHeader === "Occupied") {
              acc.push({ divider: true });
            }
            acc.push({
              header: groupHeader.toUpperCase(),
            });
          }
          acc.push(curr);
          return acc;
        },
        []
      );

      this.newAbsentReport.subDriversDisplayList = this.newAbsentReport.subDrivers;
    },
    async loadEmployees() {
      const response = await this.$http.get(
        "api/drivers/GetBusesDriverEmployees"
      );

      this.employeeList = response.map((employee) => {
        employee.displayName =
          employee.employeeID +
          " - " +
          (employee.teacherH ? employee.teacherH : employee.teacher);

        return employee;
      });
    },
    async loadBuses() {
      const response = await this.$http.get("api/drivers/GetBuses");

      this.busList = response;
    },
    async loadTerms() {
      const terms = await this.$http.get("api/allStudents/getRegTerms");

      this.terms = terms;
    },
    async loadRegID() {
      const regID = await this.$http.get("api/allStudents/getRegID");

      this.regID = regID;
    },
    async loadSeasons() {
      const seasons = await this.$http.get("api/route/getRouteSeasons");

      this.seasons = seasons.map((s) => s.season);
    },
    loadKind() {
      this.kind = getStoredRouteKind();
    },
    async datesChanged(value) {
      this.loadRoutesForDriver();
    },
    async driverBusChanged(value) {
      this.loadRoutesForDriver();
    },
    async loadRoutesForDriver() {
      this.newAbsentReport.selectedRoutes = [];

      if (
        !this.newAbsentReport.driver_bus ||
        !this.newAbsentReport.dates.length
      )
        return;

      this.newAbsentReport.loadingRoutes = true;

      try {
        const driver = this.newAbsentReport.driver_busList.find(
          (d) => d.displayName == this.newAbsentReport.driver_bus
        );

        const response = await this.$http.post(
          "api/driverAbsent/getRoutesForDriver?",
          {
            driverID: driver.id,
            regID: this.regID,
            kind: this.kind,
            dates: this.newAbsentReport.dates,
          }
        );

        this.newAbsentReport.routes = response.map((route) => {
          route.displayName =
            route.timeStart +
            " - " +
            route.routeIdentifier +
            " - " +
            route.groupBy;

          return route;
        });

        this.newAbsentReport.loadingRoutes = false;
      } catch (e) {
        this.newAbsentReport.loadingRoutes = false;
      }
    },
    async openPayPresetsDialog() {
      try {
        const presets = await this.$http.get("api/driverAbsent/getPayPresets");
        this.payPresets = {
          day: presets.day,
          am: presets.am,
          pm: presets.pm,
          trip: presets.trip,
          yearlyBonus: presets.yearlyBonus,
        };
      } catch (e) {
        this.payPresets = {
          day: 0,
          am: 0,
          pm: 0,
          trip: 0,
          yearlyBonus: 4500,
        };
      }
      this.payPresetsDialog = true;
    },
    async savePayPresets() {
      try {
        this.processing = true;
        const saved = await this.$http.post(
          "api/driverAbsent/savePayPresets",
          this.payPresets
        );
        this.payPresets = {
          day: saved.day,
          am: saved.am,
          pm: saved.pm,
          trip: saved.trip,
          yearlyBonus: saved.yearlyBonus,
        };
        this.payPresetsDialog = false;
        this.$notify({
          group: "notification",
          type: "success",
          text: "Pay presets saved",
        });
      } catch (e) {
        this.$notify({
          group: "notification",
          type: "error",
          text: "Failed to save pay presets",
        });
      } finally {
        this.processing = false;
      }
    },
    formatedDate(date) {
      return date ? moment(date).format("L") : "";
    },
    validateNewReport() {
      const validations = [
        this.$refs.driver_bus.validate(true),
        this.$refs.absentReason.validate(true),
      ];

      if (this.$refs.deductionPanel && !this.$refs.deductionPanel.validate()) {
        return false;
      }

      return validations.every(Boolean);
    },
    routeSelected(event, route) {
      console.log(event, route);
    },
    routeChoiceKey(route) {
      return route.id + "|" + (route.routeScheduleID || 0);
    },
    routeByChoice(selected) {
      return this.newAbsentReport.routes.find(
        (route) => this.routeChoiceKey(route) == selected
      );
    },
    distinctRouteIds(selected) {
      const ids = [];
      (selected || []).forEach((choice) => {
        const route = this.routeByChoice(choice);
        if (route && ids.indexOf(route.id) === -1) {
          ids.push(route.id);
        }
      });
      return ids;
    },
    getRouteGroups() {
      if (!this.newAbsentReport.routes.length) return [];

      const group = groupBy(this.newAbsentReport.routes, "groupBy");

      const order = ["AM", "PM", "CUSTOM", "FAM", "PPM"];
      return Object.keys(group).sort(function(a, b) {
        const ai = order.indexOf(a);
        const bi = order.indexOf(b);
        return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
      });
    },
    // Route keys eligible for "Select All" (FAM/PPM are opt-in only, never bulk-selected).
    selectableRouteKeys() {
      return this.newAbsentReport.routes
        .filter((r) => !["FAM", "PPM"].includes(r.groupBy))
        .map((r) => this.routeChoiceKey(r));
    },
    // Derived straight from selectedRoutes on every render, so it can never drift out of sync
    // with the actual route checkboxes (fixes the checkbox/chip getting "stuck" bug).
    isAllRoutesSelected() {
      const keys = this.selectableRouteKeys();
      if (!keys.length) return false;
      return keys.every((key) =>
        this.newAbsentReport.selectedRoutes.includes(key)
      );
    },
    toggleSelectAllRoutes() {
      const keys = this.selectableRouteKeys();
      if (!keys.length) return;

      if (this.isAllRoutesSelected()) {
        this.newAbsentReport.selectedRoutes = this.newAbsentReport.selectedRoutes.filter(
          (key) => !keys.includes(key)
        );
      } else {
        const merged = this.newAbsentReport.selectedRoutes.slice();
        keys.forEach((key) => {
          if (!merged.includes(key)) merged.push(key);
        });
        this.newAbsentReport.selectedRoutes = merged;
      }
    },
    groupRouteKeys(group) {
      return this.newAbsentReport.routes
        .filter((r) => r.groupBy == group)
        .map((r) => this.routeChoiceKey(r));
    },
    // Derived from selectedRoutes: a group chip is "checked" only when every route in that
    // group is currently selected, whether that happened via the chip or individual checkboxes.
    isGroupFullySelected(group) {
      const keys = this.groupRouteKeys(group);
      if (!keys.length) return false;
      return keys.every((key) =>
        this.newAbsentReport.selectedRoutes.includes(key)
      );
    },
    toggleRouteGroup(group) {
      const keys = this.groupRouteKeys(group);
      if (!keys.length) return;

      if (this.isGroupFullySelected(group)) {
        this.newAbsentReport.selectedRoutes = this.newAbsentReport.selectedRoutes.filter(
          (key) => !keys.includes(key)
        );
      } else {
        const merged = this.newAbsentReport.selectedRoutes.slice();
        keys.forEach((key) => {
          if (!merged.includes(key)) merged.push(key);
        });
        this.newAbsentReport.selectedRoutes = merged;
      }
    },
    getDayOfWeek(date) {
      let dayOfWeek = new Date(date).getDay() + 1;

      if (dayOfWeek == 7) {
        dayOfWeek = 0;
      }

      return isNaN(dayOfWeek)
        ? null
        : [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ][dayOfWeek];
    },
    async saveNewAbsentReport() {
      if (!this.validateNewReport()) return;

      if (!this.newAbsentReport.dates.length) {
        return this.$notify({
          text: "Date is required",
          group: "notification",
          type: "error",
        });
      }

      // if (!this.newAbsentReport.selectedRoutes.length) {
      //     return this.$notify({
      //         text: "Route is required",
      //         group: "notification",
      //         type: "error",
      //     });
      // }

      const driver = this.newAbsentReport.driver_busList.find(
        (d) => d.displayName == this.newAbsentReport.driver_bus
      );

      const subDriver = this.newAbsentReport.subDrivers.find(
        (sd) => sd.id == this.newAbsentReport.selectedSubDriver
      );

      const data = this.newAbsentReport.dates
        .map((date) => {
          if (!this.newAbsentReport.selectedRoutes.length) {
            return [
              {
                driver_Bus_ID: driver.id,
                date: date,
                enteredBy: this.$store.state.authentication.user,
                note: this.newAbsentReport.note,
                calendarNote: this.newAbsentReport.calendarNote,
                absentReason: this.newAbsentReport.absentReason,
                geoUpdated: this.newAbsentReport.geoUpdated,
                notifiedDriver: this.newAbsentReport.notifiedDriver,
                absentReasonID: this.getReasonID(
                  this.newAbsentReport.absentReason
                ),
                subDriver_Bus_ID: subDriver ? subDriver.id : null,
              },
            ];
          }

          const chosen = [];
          this.newAbsentReport.selectedRoutes.forEach((selectedRoute) => {
            const route = this.routeByChoice(selectedRoute);
            if (!route) return;
            if (
              route.weekDays &&
              !route.weekDays.includes(this.getDayOfWeek(date))
            ) {
              return;
            }
            if (chosen.some((existing) => existing.id == route.id)) return;
            chosen.push(route);
          });

          return chosen.map((route) => {
              return {
                driver_Bus_ID: driver.id,
                route_ID: route.id,
                date: date,
                enteredBy: this.$store.state.authentication.user,
                note: this.newAbsentReport.note,
                calendarNote: this.newAbsentReport.calendarNote,
                absentReason: this.newAbsentReport.absentReason,
                geoUpdated: this.newAbsentReport.geoUpdated,
                notifiedDriver: this.newAbsentReport.notifiedDriver,

                absentReasonID: this.getReasonID(
                  this.newAbsentReport.absentReason
                ),
                subDriver_Bus_ID: subDriver ? subDriver.id : null,
              };
            });
        })
        .flat();

      if (!data || !data.length) {
        return this.$notify({
          text: "Route selected does not run on selected date/s",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const response = await this.$http.post("api/driverAbsent/save", data);

        this.processing = false;

        // Check if there are unsaved absents due to duplicates
        if (
          response &&
          response.unsavedAbsents &&
          response.unsavedAbsents.length > 0
        ) {
          this.unsavedAbsents = response.unsavedAbsents;
          this.unsavedAbsentsDialog = true;

          // Show notification about the issue
          this.$notify({
            group: "notification",
            text:
              response.message ||
              `${
                response.unsavedAbsents.length
              } record(s) not saved due to duplicates`,
            type: "warning",
          });
        } else {
          // All records saved successfully
          this.$notify({
            group: "notification",
            text: "Absent report(s) saved successfully",
            type: "success",
          });
        }

        try {
          if (this.$refs.deductionPanel) {
            await this.$refs.deductionPanel.persist(driver.id);
          }
        } catch (payError) {
          this.$notify({
            group: "notification",
            text: payError.body || "Absent saved, but deduction was not saved",
            type: "warning",
          });
        }

        this.addAbsentReportDialog = false;

        this.newAbsentReport.driver_bus = "";
        this.newAbsentReport.absentReason = "";
        this.newAbsentReport.note = "";
        this.newAbsentReport.dates = [];
        this.newAbsentReport.routes = [];
        this.newAbsentReport.selectedRoutes = [];
        this.newAbsentReport.selectedSubDriver = "";
        if (this.$refs.deductionPanel) {
          this.$refs.deductionPanel.reset();
        }

        this.$refs.grid.reloadGrid();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    getReasonID(reason) {
      const data = this.reasons.find((r) => r.reason == reason);

      return data ? data.id : null;
    },
    async onRowClicked(row) {
      this.rowClicked = JSON.parse(JSON.stringify(row));
      this.updateAbsentReportDialog = true;
    },
    closeAbsentReportDialog() {
      this.updateAbsentReportDialog = false;
    },
    reload() {
      this.$refs.grid.reloadGrid();
    },
    async addAbsentReport() {
      this.newAbsentReport.dates = [];
      this.newAbsentReport.driver_bus = "";
      this.newAbsentReport.route = "";
      this.newAbsentReport.routes = [];
      this.newAbsentReport.selectedRoutes = [];
      this.newAbsentReport.selectedSubDriver = "";
      this.newAbsentReport.subDriverListFilter = "all";
      if (this.$refs.deductionPanel) {
        this.$refs.deductionPanel.reset();
      }

      await this.loadNewAbsentReportSubDriverList();
      this.addAbsentReportDialog = true;
    },
    async openDeleteAbsentReports() {
      this.selected = this.$refs.grid.getSelectedRowsData();
      this.payImpactDays = [];
      this.deleteDialog = true;
      this.payImpactLoading = true;

      try {
        this.payImpactDays = await this.$http.post(
          "api/driverAbsent/previewPayImpact",
          this.selected.map((row) => ({
            absentID: row.id,
            action: "delete",
          }))
        );
      } catch (e) {
        this.payImpactDays = [];
        this.$notify({
          group: "notification",
          text: "Could not check how pay will change",
          type: "error",
        });
      } finally {
        this.payImpactLoading = false;
      }
    },
    openChangeRoute() {
      this.selected = this.$refs.grid.getSelectedRowsData();

      this.changeRouteDialog = true;
    },
    closeChangeRouteDialog() {
      this.changeRouteDialog = false;
    },
    openDriverReportDialog() {
      this.driverReport.driver_buses = [];
      this.driverReport.fromDate = "";
      this.driverReport.toDate = "";
      this.driverReport.fromDatePickerMenu = false;
      this.driverReport.toDatePickerMenu = false;
      this.driverReport.dateRangePreset = "";
      this.driverReport.reportMode = "summary";
      this.driverReport.seasonMode = "auto";
      this.driverReport.season = this.season;
      this.driverReport.regID = this.regID;

      this.driverReportDialog = true;
    },
    setDriverReportRange(preset) {
      const today = moment();
      const lastYear = today.year() - 1;

      if (preset === "all") {
        this.driverReport.fromDate = moment()
          .year(lastYear - 1)
          .startOf("year")
          .format("YYYY-MM-DD");
        this.driverReport.toDate = today.format("YYYY-MM-DD");
      } else if (preset === "lastYear") {
        this.driverReport.fromDate = moment()
          .year(lastYear)
          .startOf("year")
          .format("YYYY-MM-DD");
        this.driverReport.toDate = moment()
          .year(lastYear)
          .endOf("year")
          .format("YYYY-MM-DD");
      } else if (preset === "thisYear") {
        this.driverReport.fromDate = today
          .clone()
          .startOf("year")
          .format("YYYY-MM-DD");
        this.driverReport.toDate = today.format("YYYY-MM-DD");
      } else if (preset === "janJulLastYear") {
        this.driverReport.fromDate = moment(`${lastYear}-01-01`).format(
          "YYYY-MM-DD"
        );
        this.driverReport.toDate = moment(`${lastYear}-07-31`).format(
          "YYYY-MM-DD"
        );
      }

      this.driverReport.dateRangePreset = preset;
      this.driverReport.fromDatePickerMenu = false;
      this.driverReport.toDatePickerMenu = false;
      this.$nextTick(() => {
        if (this.$refs.driverReportFromDate) {
          this.$refs.driverReportFromDate.validate();
        }
        if (this.$refs.driverReportToDate) {
          this.$refs.driverReportToDate.validate();
        }
      });
    },
    onDriverReportDatePicked(which) {
      if (this.driverReport.skipPickerClose) return;

      this.driverReport.dateRangePreset = "";
      if (which === "from") {
        this.driverReport.fromDatePickerMenu = false;
      } else {
        this.driverReport.toDatePickerMenu = false;
      }
    },
    jumpDriverReportPickerYear(which, delta) {
      const current =
        which === "from"
          ? this.driverReport.fromDate
          : this.driverReport.toDate;
      const next = (current ? moment(current) : moment()).add(delta, "years");

      this.driverReport.skipPickerClose = true;
      if (which === "from") {
        this.driverReport.fromDate = next.format("YYYY-MM-DD");
      } else {
        this.driverReport.toDate = next.format("YYYY-MM-DD");
      }
      this.driverReport.dateRangePreset = "";
      this.$nextTick(() => {
        this.driverReport.skipPickerClose = false;
      });
    },
    selectAllDriverBuses() {
      this.driverReport.driver_buses = this.newAbsentReport.driver_busList.map(
        (b) => b.displayName
      );
    },
    validateDriverReportInput() {
      const validations = [
        this.$refs.driverReportFromDate.validate(true),
        this.$refs.driverReportToDate.validate(true),
      ];

      return validations.every(Boolean);
    },
    async loadDriverReport() {
      if (!this.driverReport.driver_buses.length) {
        return this.$notify({
          text: "Please select driver",
          group: "notification",
          type: "error",
        });
      }
      if (!this.validateDriverReportInput()) return;

      try {
        this.processing = true;

        const driverIDs = this.driverReport.driver_buses.map((driverBus) => {
          const driver = this.newAbsentReport.driver_busList.find(
            (d) => d.displayName == driverBus
          );

          return driver.id;
        });

        const response = await this.$http.post(
          "api/driverAbsent/getDriverReport?",
          {
            driverIDs: driverIDs,
            fromDate: this.driverReport.fromDate,
            toDate: this.driverReport.toDate,
            reportMode: this.driverReport.reportMode,
            seasonMode: this.driverReport.seasonMode,
            season: this.driverReport.season,
            regID: this.driverReport.regID,
          }
        );

        this.generateCSV(response);

        this.processing = false;
        this.driverReportDialog = false;
      } catch (e) {
        this.processing = false;
      }
    },
    generateCSV(response) {
      // Define column headers
      const headers = [
        "Driver / Bus",
        "Date",
        "Description",
        "Trips Missed",
        "Covered By",
        "Paid By",
        "Hebrew Date",
        "Absent Details",
        "Calendar Note",
        "Absent Note",
        "Season",
      ];

      // Add header row
      let csvContent = headers.join(",") + "\n";
      const csvCell = (value) =>
        `"${String(value == null ? "" : value).replace(/"/g, '""')}"`;

      response.forEach((report) => {
        if (!report.length) return;

        const driver = this.newAbsentReport.driver_busList.find(
          (d) => d.id == report[0].driverID
        );

        const driverName = driver ? driver.displayName : "";

        // Add data rows
        report.forEach((item) => {
          const row = [
            csvCell(driverName),
            csvCell(item.date),
            csvCell(item.description),
            csvCell(item.tripsMissed),
            csvCell(item.coveredBy),
            csvCell(item.paidBy),
            csvCell(item.hebrewDate),
            csvCell(item.absentDetails),
            csvCell(item.calendarNote),
            csvCell(item.absentNote),
            csvCell(item.season),
          ];
          csvContent += row.join(",") + "\n";
        });
      });

      // Create and trigger download
      const blob = new Blob(["\uFEFF" + csvContent], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "driver_report.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async openUpdateSubDrivers() {
      this.selected = this.$refs.grid.getSelectedRowsData();

      const absentIDs = this.selected.map((d) => d.id);

      const response = await this.$http.post(
        "api/driverAbsent/getSubDrivers",
        absentIDs
      );

      this.subDrivers = response
        .map((driver) => {
          driver.displayName =
            (driver.nameH ? driver.nameH : driver.name) +
            " (" +
            driver.busNumber +
            ")";

          // driver.group = driver.isOccupied
          //     ? "Occupied"
          //     : "Not Occupied";
          driver.group = "";

          if (driver.position == "Substitute")
            driver.group += ` <span class='substitute-option'>Substitute</span>`;

          return driver;
        })
        .sort((a, b) => {
          if (a.group < b.group) {
            return -1;
          }
          if (a.group > b.group) {
            return 1;
          }
          return 0;
        });

      this.subDrivers = this.subDrivers.reduce((acc, curr) => {
        const { group } = curr;

        let groupHeader = group;

        groupHeader = groupHeader.replace(
          ` <span class='substitute-option'>Substitute</span>`,
          ``
        );

        const foundIndex = acc.findIndex((item) => item.group === groupHeader);
        // if group is not yet added
        if (foundIndex === -1) {
          // add divider after full list of Not Occupied
          if (groupHeader === "Occupied") {
            acc.push({ divider: true });
          }
          acc.push({ header: groupHeader.toUpperCase() });
        }
        acc.push(curr);
        return acc;
      }, []);

      this.subDriversDisplayList = this.subDrivers;

      this.updateSubDriverDialog = true;
    },
    subDriverListFilterChanged(value) {
      if (this.updateAbsentReportDialog) {
        this.updateAbsentReport.subDriversDisplayList =
          value == "all"
            ? this.updateAbsentReport.subDrivers
            : this.updateAbsentReport.subDrivers.filter(
                (s) => s.group == "Not Occupied"
              );

        return;
      }

      this.subDriversDisplayList =
        value == "all"
          ? this.subDrivers
          : this.subDrivers.filter((s) => s.group == "Not Occupied");
    },
    newAbsentReportSubDriverListFilterChanged(value) {
      this.newAbsentReport.subDriversDisplayList =
        value == "all"
          ? this.newAbsentReport.subDrivers
          : this.newAbsentReport.subDrivers.filter(
              (s) => s.group == "Not Occupied"
            );
    },
    removeSubDriver(item) {
      this.selectedSubDriver = "";

      // if (this.updateAbsentReportDialog) {
      //     this.updateAbsentReport.selectedSubDriver = "";
      // } else {
      //     this.selectedSubDriver = "";
      // }
    },
    removeNewAbsentReportSubDriver(item) {
      this.newAbsentReport.selectedSubDriver = "";
    },
    async saveSubDriver() {
      try {
        this.processing = true;

        const subDriver = this.subDrivers.find(
          (sd) => sd.id == this.selectedSubDriver
        );

        const data = this.selected.map((absent) => {
          absent.subDriver_Bus_ID = subDriver ? subDriver.id : null;
          absent.notifiedDriver = this.notifiedDriver;
          absent.geoUpdated = this.geoUpdated;

          return absent;
        });

        await this.$http.post("api/driverAbsent/save", data);

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.notifiedDriver = "";
        this.geoUpdated = "";

        this.$refs.grid.reloadGrid();

        this.updateSubDriverDialog = false;
        this.selectedSubDriver = "";
        this.processing = false;
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    validate() {
      const validations = [];

      this.$refs.busNumber.map((busNumber) => {
        validations.push(busNumber.validate(true));
      });

      return validations.every(Boolean);
    },
    async deleteReports(decisions) {
      try {
        const ids = this.selected.map((s) => s.id);

        this.processing = true;

        await this.$http.post("api/driverAbsent/deleteWithPay", {
          ids: ids,
          decisions: decisions || [],
        });

        this.processing = false;
        this.deleteDialog = false;
        this.updateAbsentReportDialog = false;

        this.$notify({
          group: "notification",
          text: ids.length + " Deleted",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
        this.$notify({
          group: "notification",
          text:
            (e && e.body && e.body.message) ||
            "Delete was not saved. Check the pay choices and try again.",
          type: "error",
        });
      }
    },
    async saveAbsentReport() {
      if (!this.rowClicked.date) {
        return this.$notify({
          text: "Date is required",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const subDriver = this.updateAbsentReport.subDrivers.find(
          (sd) => sd.id == this.updateAbsentReport.selectedSubDriver
        );

        await this.$http.post("api/driverAbsent/save", [
          {
            id: this.rowClicked.id,
            driver_Bus_ID: this.rowClicked.driver_Bus_ID,
            route_ID: this.rowClicked.route_ID,
            date: this.rowClicked.date,
            subDriver_Bus_ID: subDriver ? subDriver.id : null,
          },
        ]);

        this.processing = false;
        this.updateAbsentReportDialog = false;

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
  },
};
</script>
<style>
.gray-fg {
  color: #999;
}
.substitute-option {
  font-size: 12px;
  background-color: purple;
  color: #fff;
  width: fit-content;
  padding: 3px;
  margin-bottom: 2px;
  border-radius: 5px;
}
.error-border {
  border: 2px solid #ff5252 !important;
  border-left: 4px solid #ff5252 !important;
}
.routes-section-card {
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
}
.route-select-toolbar {
  padding: 4px 4px 10px;
  margin-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}
.route-select-all {
  margin-bottom: 6px !important;
}
.route-group-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-top: 6px;
}
.route-group-caption {
  margin-right: 10px;
  line-height: 26px;
}
.route-group-chip {
  display: inline-flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 16px;
  padding: 2px 10px 2px 4px;
  margin: 0 6px 6px 0;
  cursor: pointer;
  font-size: 13px;
  color: #424242;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.route-group-chip:hover {
  border-color: #66bb6a;
}
.route-group-chip--checked {
  background-color: #e8f5e9;
  border-color: #4caf50;
  color: #2e7d32;
  font-weight: 500;
}
.route-group-check {
  flex: 0 0 auto !important;
  width: auto !important;
  max-width: none;
  margin-right: 4px !important;
  pointer-events: none;
}
.route-group-check.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
.route-group-check .v-input__control,
.route-group-check .v-input__slot {
  min-height: 0;
}
.route-list-scroll {
  padding-top: 2px;
}
</style>
